export const MetricStage = {
  DISPLAY: 'display', // 展示耗时
  TOTAL: 'total', // 总耗时

  PREFETCH_LOGIC_BEFORE: 'prefetch_logic_before',
  PREFETCH: 'prefetch',
  PREFETCH_LOGIC_AFTER: 'prefetch_logic_after',

  TOKEN_LOGIC_BEFORE: 'token_logic_before',
  TOKEN: 'token',
  TOKEN_LOGIC_AFTER: 'token_logic_after',

  RESOURCE_LOGIC_BEFORE: 'resource_logic_before',
  RESOURCE: 'resource',
  RESOURCE_LOGIC_AFTER: 'resource_logic_after',

  JSURL_LOGIC_BEFORE: 'jsurl_logic_before',
  JSURL: 'jsurl',
  JS_EXCUTE: 'js_excute',

  JS_CHALLENGE_ENCRYPT: 'js_challenge_encrypt',

  SEND: 'send',

  IMAGE_LOGIC_BEFORE: 'image_logic_before',
  IMAGE: 'image',
  IMAGE_LOGIC_AFTER: 'image_logic_after',

  CHECK_LOGIC_BEFORE: 'check_logic_before',
  CHECK: 'check',
  CHECK_LOGIC_AFTER: 'check_logic_after',

  NINE_CAPTCHA_REFRESH: 'refresh_count',
  NINE_CAPTCHA_OPERATION_COUNT: 'operation_count',

  DEVICE_BEFORE: 'device_before',
  DEVICE: 'device',
  DEVICE_AFTER_SUCCESS: 'device_after_success',
  DEVICE_LOADIND_RESOURCE_TIME: 'device_resource_loading_time',
  DEVICE_LOADIND_CHECK_TIME: 'device_check_loading_time',
};

export const Metric = {
  [MetricStage.DISPLAY]: 's1',

  [MetricStage.TOTAL]: 's2',

  [MetricStage.PREFETCH_LOGIC_BEFORE]: 't9',

  [MetricStage.PREFETCH]: 't10',

  [MetricStage.PREFETCH_LOGIC_AFTER]: 't11',

  [MetricStage.TOKEN_LOGIC_BEFORE]: 't19',

  [MetricStage.TOKEN]: 't20',

  [MetricStage.TOKEN_LOGIC_AFTER]: 't21',

  [MetricStage.RESOURCE_LOGIC_BEFORE]: 't29',

  [MetricStage.RESOURCE]: 't30',

  [MetricStage.RESOURCE_LOGIC_AFTER]: 't31',

  [MetricStage.JSURL_LOGIC_BEFORE]: 't39',

  [MetricStage.JSURL]: 't40',

  [MetricStage.JS_EXCUTE]: 't41',

  [MetricStage.JS_CHALLENGE_ENCRYPT]: 't42',

  [MetricStage.SEND]: 't45',

  [MetricStage.IMAGE_LOGIC_BEFORE]: 't49',

  [MetricStage.IMAGE]: 't50',

  [MetricStage.IMAGE_LOGIC_AFTER]: 't51',

  [MetricStage.CHECK_LOGIC_BEFORE]: 't59',

  [MetricStage.CHECK]: 't60',

  [MetricStage.CHECK_LOGIC_AFTER]: 't61',

  [MetricStage.NINE_CAPTCHA_REFRESH]: 'n1',
  [MetricStage.NINE_CAPTCHA_OPERATION_COUNT]: 'n2',

  [MetricStage.DEVICE_BEFORE]: 'd1',
  [MetricStage.DEVICE_AFTER_SUCCESS]: 'd2',
  [MetricStage.DEVICE_LOADIND_RESOURCE_TIME]: 'd3',
  [MetricStage.DEVICE_LOADIND_CHECK_TIME]: 'd4',
};

export const ReportMetricList = [
  Metric[MetricStage.DISPLAY],
  Metric[MetricStage.TOTAL],
  Metric[MetricStage.TOKEN],
  Metric[MetricStage.RESOURCE],
  Metric[MetricStage.JSURL],
  Metric[MetricStage.JS_EXCUTE],
  Metric[MetricStage.SEND],
  Metric[MetricStage.IMAGE],
  Metric[MetricStage.CHECK],
  Metric[MetricStage.NINE_CAPTCHA_REFRESH],
  Metric[MetricStage.NINE_CAPTCHA_OPERATION_COUNT],

  Metric[MetricStage.DEVICE_BEFORE],
  Metric[MetricStage.DEVICE_AFTER_SUCCESS],
  Metric[MetricStage.DEVICE_LOADIND_RESOURCE_TIME],
  Metric[MetricStage.DEVICE_LOADIND_CHECK_TIME],
];
